module.exports = "/static/assets/132acc314440b901152ad805d8911aaf.png";